import { BrltlFreightItemTable } from "../BrltlFreightItemTable";
import { MovementTabs } from "../MovementTabs";
import { OrderHandlingRequirements } from "../OrderHandlingRequirements";
import { OrderOverview } from "../OrderOverview";
import { OrderRates } from "../OrderRates";
import { ShipperPONums } from "../ShipperPONums";
import { Button, Checkbox, CityState, DataHeader, DataSource, HorizontalSpacer, Image, Label, Layout, NumberEditor, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrders extends Layout {
    andLabel: Label;
    buttonAddAnotherStop: Button;
    buttonAssignCarrier: Button;
    buttonAssignDriver: Button;
    buttonAutoMatch: Button;
    buttonCarrierRates: Button;
    buttonDeliveryReceipt: Button;
    buttonEnterNewOrder: Button;
    buttonFindCarrier: Button;
    buttonInitiateStatusProcessing: Button;
    buttonOpenClassic: Button;
    buttonOrderHistory: Button;
    buttonOrderHistoryWithAlerts: Button;
    buttonReleaseToBilling: Button;
    buttonSendBOL: Button;
    buttonShare: Button;
    buttonUsers: Button;
    buttonViewOrder: Button;
    checkboxBolReceived: Checkbox;
    checkboxExpedited: Checkbox;
    checkboxFloorLoadedFreight: Checkbox;
    checkboxHighValue: Checkbox;
    checkboxPreloaded: Checkbox;
    checkboxReadyToBill: Checkbox;
    checkboxRoundTrip: Checkbox;
    checkboxTarps: Checkbox;
    checkboxTeamsRequired: Checkbox;
    dataheaderOrders: DataHeader;
    horizontalspacer1: HorizontalSpacer;
    howManyOrders: NumberEditor;
    imageAddHandlingReq: Image;
    labelAfterThisOrderIsSavedIWantTo: Label;
    labelCreditBadge: Label;
    labelCustomsBroker: Label;
    labelCustomsCoBroker: Label;
    labelHazmatCommodity: Label;
    labelHoldBadge: Label;
    labelHowManyOrders: Label;
    labelInvoiceHistory: Label;
    labelMovementView: Label;
    labelOrderView: Label;
    labelPreferredBorderCrossings: Label;
    labelStatusBadge: Label;
    labelTemperatureRange: Label;
    labelTractorId: Label;
    layoutFreightItems: BrltlFreightItemTable;
    layoutHandlingReqs: OrderHandlingRequirements;
    layoutImageTable: Layout;
    layoutMovementTabs: MovementTabs;
    layoutOverview: OrderOverview;
    layoutRates: OrderRates;
    layoutShipperPONums: ShipperPONums;
    panel10: Panel;
    panel11: Panel;
    panel12: Panel;
    panel13: Panel;
    panel1: Panel;
    panel3: Panel;
    panel5: Panel;
    panel6: Panel;
    panel7: Panel;
    panel9: Panel;
    panelBatchOrder: Panel;
    panelBorderCrossings: Panel;
    panelBrokerLocations: Panel;
    panelCbpCrossing: Panel;
    panelCbsaCrossing: Panel;
    panelCommodityCheckboxes: Panel;
    panelCommodityExtra: Panel;
    panelCommodityHazmat: Panel;
    panelCustoms: Panel;
    panelCustomsBrokers: Panel;
    panelDataHeaderUpdateOnly: Panel;
    panelEquipTypeOptions: Panel;
    panelGeneralUpdate: Panel;
    panelHazmatComponents: Panel;
    panelHowManyOrders: Panel;
    panelInvoiceHistoryTab: Panel;
    panelLoadBoardFields: Panel;
    panelMovementTab: Panel;
    panelNextActionButtonContainer: Panel;
    panelNextActionButtons: Panel;
    panelNextActions: Panel;
    panelOrderTab: Panel;
    panelOrderTabs: Panel;
    panelTemperatureRange: Panel;
    postingCityState: CityState;
    sourceBrltlBillingFreightGroup: DataSource;
    sourceBrltlOrderFreightGroupItem: DataSource;
    sourceBrltlOrderHdrXFgp: DataSource;
    sourceEquipMatchDetail: DataSource;
    sourceMovement: DataSource;
    sourceOrders: DataSource;
    sourceResponsibleHist: DataSource;
    sourceStop: DataSource;
    stopsTable: Table;
    switchBatchOrder: Switch;
    switchHazmatRouting: Switch;
    switchHoldLoad: Switch;
    switchPostToAllServices: Switch;
    switchPostToLoadBoards: Switch;
    switchPostToLoadBoardsNextAction: Switch;
    switchRecurringOrder: Switch;
    switchTenderReplyTransmitted: Switch;
    tabAccessorials: Tab;
    tabBackOffice: Tab;
    tabBrltlFreightItems: Tab;
    tabCommodity: Tab;
    tabCustoms: Tab;
    tabDataFusion: Tab;
    tabEquipment: Tab;
    tabGeneral: Tab;
    tabImages: Tab;
    tabLoadBoardDetails: Tab;
    tabNextActions: Tab;
    tabOverview: Tab;
    tabRate: Tab;
    tabSpotOrder: Tab;
    tabStops: Tab;
    tableEquipmentRequirementsAsset: Table;
    tableEquipmentRequirementsBrokerage: Table;
    tabsetAddOrders: Tabset;
    textboxAccountManager: Textbox;
    textboxAgentPayeeId: Textbox;
    textboxAutoRateId: Textbox;
    textboxBillDate: Textbox;
    textboxBillingUserId: Textbox;
    textboxBlnum2: Textbox;
    textboxBlnum: Textbox;
    textboxBolNote: Textbox;
    textboxBolRecvDate: Textbox;
    textboxBrkQualProfile: Textbox;
    textboxBrokerLocationId: Textbox;
    textboxBrokerageWorkflowId: Textbox;
    textboxCbpCrossingDate: Textbox;
    textboxCbpCrossingLocationId: Textbox;
    textboxCbpCrossingReason: Textbox;
    textboxCbsaCrossingDate: Textbox;
    textboxCbsaCrossingLocationId: Textbox;
    textboxCbsaCrossingReason: Textbox;
    textboxCobrokerLocationId: Textbox;
    textboxCommodity: Textbox;
    textboxCommodityId: Textbox;
    textboxConsigneeRefno: Textbox;
    textboxCopyFromCompany: Textbox;
    textboxCopyFromOrderId: Textbox;
    textboxCopyToCompany: Textbox;
    textboxCopyToOrderId: Textbox;
    textboxCustomerId: Textbox;
    textboxDefMoveType: Textbox;
    textboxEnteredUserId: Textbox;
    textboxEquipmentTypeIdEquipment: Textbox;
    textboxEquipmentTypeIdGeneral: Textbox;
    textboxExternalInvoiceno: Textbox;
    textboxHazmatCode: Textbox;
    textboxHoldReason: Textbox;
    textboxInvoiceRecvDate: Textbox;
    textboxOrderLength: Textbox;
    textboxOrderMode: Textbox;
    textboxOrderNumber: Textbox;
    textboxOrderOrderedBy: Textbox;
    textboxOrderType: Textbox;
    textboxOrderValue: Textbox;
    textboxOrderValueCurrency: Textbox;
    textboxOrderedDate: Textbox;
    textboxOrderedMethod: Textbox;
    textboxOutboundStatusCompleted: Textbox;
    textboxOverrideArriveEarly: Textbox;
    textboxOverrideArriveLate: Textbox;
    textboxPalletsHowMany: Textbox;
    textboxPieces: Textbox;
    textboxPlanningComment: Textbox;
    textboxPnnCallback: Textbox;
    textboxPnnComment2: Textbox;
    textboxPnnComment: Textbox;
    textboxPnnLoadboardUserId: Textbox;
    textboxPnnRate: Textbox;
    textboxPnnRateType: Textbox;
    textboxPnnTrailerLength: Textbox;
    textboxPnnTrailerWidth: Textbox;
    textboxPreferredVendors: Textbox;
    textboxPreloadTrailerId: Textbox;
    textboxRateSource: Textbox;
    textboxRecurringOrderId: Textbox;
    textboxRevenueCodeId: Textbox;
    textboxSalespersonId: Textbox;
    textboxShipmentId: Textbox;
    textboxSubjectOrderNumber: Textbox;
    textboxSubjectOrderStatus: Textbox;
    textboxSubjectOrderVoidDate: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
    textboxTractorType: Textbox;
    textboxTurnoverNotes: Textbox;
    textboxWeight: Textbox;
    textboxXferred2billingDt: Textbox;
}
